import { CcLibraryHeading, CcLibraryHeadingList } from "server/models"

export type CcLibraryHeadingValidation = { [key in keyof CcLibraryHeading]?: string}

export interface CcLibraryHeadingState {
    headingList: CcLibraryHeadingList
    headingEdit: CcLibraryHeading
    reloadEdit: boolean

    availableParents: CcLibraryHeading[]
    availableParentsFiltered: CcLibraryHeading[]
    availableParentSearch: string

    menuTargetId: number
    menuTargetElement: any

    confirmDelete: CcLibraryHeading
}

export const CC_LIBRARY_HEADING_LIST = "CC_LIBRARY_HEADING_LIST"
export const CC_LIBRARY_HEADING_EDIT = "CC_LIBRARY_HEADING_EDIT"
export const CC_LIBRARY_HEADING_RELOAD_EDIT = "CC_LIBRARY_HEADING_RELOAD_EDIT"

export const CC_LIBRARY_HEADING_AVAILABLE_PARENTS = "CC_LIBRARY_HEADING_AVAILABLE_PARENTS"
export const CC_LIBRARY_HEADING_AVAILABLE_PARENTS_FILTERED = "CC_LIBRARY_HEADING_AVAILABLE_PARENTS_FILTERED"
export const CC_LIBRARY_HEADING_AVAILABLE_PARENT_SEARCH = "CC_LIBRARY_HEADING_AVAILABLE_PARENT_SEARCH"

export const CC_LIBRARY_HEADING_MENU = "CC_LIBRARY_HEADING_MENU"
export const CC_LIBRARY_HEADING_CONFIRM_DELETE = "CC_LIBRARY_HEADING_CONFIRM_DELETE"
